import "./Navbar.css";
import logo from "./Rev Logo.png";

function Navbar() {
  return (
    <header className="navbar">
      <div className="navbar-brand">
        <img
          src={logo}
          alt="The REV Project"
          className="navbar-logo"
        />
      </div>

      <div className="navbar-title">
        <h1>REV Dashboard</h1>
        <p>Electric Vehicle Charging Data Visualisation</p>
      </div>
    </header>
  );
}

export default Navbar;